import React from "react"

import ReviewStars from "../../components/shared/ReviewStars"
import Typography from "../../components/shared/Typography"

const ReviewCardSignature = ({ review, children }) => {
  const isAnonymous = review.isAnonymous
  const name =
    review.client?.firstName || review.user?.firstName || review.unverifiedName || review.unverified_name || ""
  const lastName = review.client?.lastName || review.user?.lastName || ""
  const firstName =
    (name != null && String(name).trim() !== "" && String(name).trim().toLowerCase() !== "undefined"
      ? String(name).split(" ")[0]
      : "") || ""
  const lastInitial =
    lastName && String(lastName).trim().toLowerCase() !== "undefined" ? `${String(lastName)[0]}.`.toUpperCase() : ""
  const displayName = isAnonymous
    ? "Anonymous"
    : [firstName, lastInitial].filter(Boolean).join(" ").trim() || "Anonymous"

  return (
    <div className="flex w-full flex-wrap items-center gap-2">
      <Typography variant="small" as="div" className="hidden text-gray-dark sm:block">
        {displayName} • {review.createdAtAgoInWords}
      </Typography>
      <Typography variant="small" as="div" className="text-gray-dark sm:hidden">
        {displayName} • {review.createdAtAgoInWords}
      </Typography>
      <ReviewStars rating={review.rating} />
      {children}
    </div>
  )
}

export default ReviewCardSignature
